export const localesViEn = {
    vi: {
        nav_home: "Trang chủ", nav_explore: "Khám phá", nav_media: "Media", nav_references: "Tham khảo", nav_chat: "Chat & Hỗ trợ",
        search_placeholder: "Tìm kiếm...",
        search_clear_aria: "Xóa tìm kiếm",
        mobile_search_title: "Tìm kiếm",
        lang_btn_aria: "Thay đổi ngôn ngữ",
        theme_btn_aria: "Chuyển chế độ sáng/tối",
        search_filter_all: "Tất cả", search_filter_articles: "Bài viết", search_filter_video: "Video", search_filter_audio: "Audio",
        search_recent: "Gần đây", search_clear_all: "Xóa tất cả", search_trending: "Xu hướng tìm kiếm", search_featured: "Gợi ý nổi bật",
        search_no_results: "Không tìm thấy kết quả phù hợp", search_history: "Lịch sử tìm kiếm",
        search_trending_title: "Chủ đề phổ biến", search_all_results_for: "Xem tất cả kết quả cho",
        home_badge: "Lắng Nghe Tâm Hồn",
        home_title: "Điều kỳ diệu ở Huế",
        card_health: "Sức khỏe", card_work: "Công việc", card_love: "Tình duyên", card_family: "Gia đình",
        card_spirit: "Tâm linh", card_science: "Khoa học", card_culture: "Văn hóa truyền thống",
        explore_now: "Khám phá ngay →", read_mins: "phút đọc",
        card_finance: "Tài chính", card_reincarnation: "Xuyên không / Luân hồi",
        card_hue: "Huế", prompt_hue: "Điều kỳ diệu ở Huế",
        card_danang: "Đà Nẵng", prompt_danang: "Điều kỳ diệu ở Đà Nẵng",
        card_binhdinh: "Bình Định", prompt_binhdinh: "Điều kỳ diệu ở Bình Định",
        card_vungtau: "Vũng Tàu", prompt_vungtau: "Điều kỳ diệu ở Vũng Tàu",
        card_bentre: "Bến Tre", prompt_bentre: "Điều kỳ diệu ở Bến Tre",
        story_answer_btn: "ĐÁP ÁN: VÌ SAO CÓ NHÂN LOẠI",
        story_close_aria: "Đóng câu chuyện",
        story_next_aria: "Trang kế tiếp",
        story_prev_aria: "Trang trước",
        quiz_step_1: "Bước 1/2", quiz_step_2: "Bước 2/2",
        quiz_continue: "Tiếp tục", quiz_find_answer: "Tìm câu trả lời", quiz_back: "Chọn lại",
        quiz_your_choice: "Bạn đã chọn", quiz_close_aria: "Đóng", quiz_hint: "Chọn một đáp án để tiếp tục",
        carousel_prev_aria: "Chủ đề trước", carousel_next_aria: "Chủ đề kế tiếp",
        master_banner_author: "Nhà sáng lập Pháp Luân Đại Pháp công bố bài viết:",
        banner_title_1: "VÌ SAO CÓ NHÂN LOẠI",
        banner_title_2: "TẠI SAO CẦN PHẢI<br>CỨU ĐỘ CHÚNG SINH",
        banner_title_3: "VÌ SAO XÃ HỘI<br>NHÂN LOẠI LÀ MÊ?",
        spotlight_title: "BÀI CHỌN LỌC",
        "sec_nhung-cau-chuyen-than-ky": "Những câu chuyện thần kỳ",
        "sec_gioi-thieu-phap-luan-dai-phap": "Giới thiệu Pháp Luân Đại Pháp",
        "sec_vung-dat-con-nguoi": "Vùng đất - Con người",
        "sec_chan-tuong-cuoc-buc-hai": "Chân tướng cuộc bức hại",
        "sec_van-hoa": "Văn hoá",
        "sec_video": "Video",
        "sec_su-kien": "Sự kiện",
        view_more: "Xem thêm", read_more: "Đọc tiếp", share_action: "Chia sẻ",
        network_title: "Liên kết tham khảo",
        desc_mrsecret: "Giải mã bí ẩn vũ trụ và nhân loại",
        desc_tantheky: "Thời báo tin tức chân thực, nhân văn",
        desc_ganjing: "Nền tảng video trong sạch & an toàn",
        desc_zhengjian: "Văn hóa truyền thống & khoa học sinh mệnh",
        desc_minghui: "Thông tin Pháp Luân Đại Pháp toàn cầu",
        desc_falundafa: "Trang thông tin chính thức về Pháp Luân Đại Pháp",
        desc_shenyun: "Phục hưng 5000 năm văn minh truyền thống",
        desc_newcentury: "Hãng phim độc lập truyền cảm hứng",
        breadcrumb_home: "Trang chủ", breadcrumb_explore: "Khám phá", breadcrumb_category: "Chuyên mục",
        back: "Quay lại", all_articles: "Tất cả bài viết", articles_unit: "bài viết",
        loading_more_articles: "Đang tải thêm bài viết...", load_more_btn: "Xem thêm bài viết",
        all_articles_loaded: "Đã hiển thị tất cả bài viết",
        no_articles_in_cat: "Chưa có bài viết cho mục này",
        no_articles_hint: "Vui lòng chọn danh mục khác hoặc đặt lại bộ lọc để khám phá các bài viết bổ ích.",
        view_all_articles_btn: "Xem tất cả bài viết",
        story_posted_by: "Đăng bởi dieukydieu.tv • Khám phá chuyên sâu",
        media_title: "Kho Media", media_filter_all: "Tất cả", media_filter_video: "Video", media_filter_audio: "Audio",
        livechat_header_title: "Hỗ trợ dieukydieu.tv", livechat_online_status: "● Đang trực tuyến",
        livechat_welcome_msg: "Xin chào bạn! dieukydieu.tv luôn sẵn lòng lắng nghe và chia sẻ cùng bạn về những điều kỳ diệu, giải đáp thắc mắc về Pháp Luân Đại Pháp, thiền định hay khoa học sinh mệnh. Bạn muốn tìm hiểu điều gì hôm nay?",
        livechat_sug_1: "Pháp Luân Đại Pháp là gì?",
        livechat_sug_2: "Hướng dẫn học 5 bài công pháp",
        livechat_sug_3: "Khỏi bệnh thần kỳ có thật không?",
        livechat_input_placeholder: "Nhập câu hỏi hoặc chia sẻ của bạn...",
        livechat_send_aria: "Gửi tin nhắn", livechat_close_aria: "Đóng chat", chat_bubble_aria: "Mở khung trò chuyện hỗ trợ",
        share_modal_title: "Chia Sẻ Bài Viết", share_copy_link_btn: "Copy link",
        share_qr_instruction: "HOẶC QUÉT MÃ QR TRÊN ĐIỆN THOẠI", share_copy_action: "Sao chép",
        toast_copied_text: "Đã sao chép liên kết!",
        player_playing_from: "ĐANG PHÁT TỪ", player_source_title: "Tuyển tập thanh tịnh",
        player_default_title: "Tiêu đề bài hát", player_default_artist: "Nghệ sĩ",
        player_tab_track: "BÀI HÁT", player_tab_queue: "TIẾP THEO", player_tab_lyrics: "LỜI BÀI HÁT",
        player_queue_heading: "Danh sách bài hát", player_shuffle_btn: "Trộn bài",
        player_lyrics_heading: "Lời bài hát", player_lyrics_updating: "Đang cập nhật lời bài hát...",
        player_options_title: "Tùy chọn bài hát", player_sleep_timer: "Hẹn giờ tắt nhạc",
        player_timer_off: "Đang tắt", player_timer_min_suffix: "phút",
        player_speed: "Tốc độ phát", player_speed_normal: "1.0x (Bình thường)", player_speed_normal_word: "Bình thường",
        player_share: "Chia sẻ bài hát", player_share_sub: "Sao chép liên kết hoặc gửi bạn bè",
        player_stop: "Tắt trình phát nhạc",
        player_timer_15m: "15 phút", player_timer_30m: "30 phút", player_timer_45m: "45 phút", player_timer_60m: "60 phút",
        player_timer_track_end: "Hết bài này", player_timer_cancel_btn: "Tắt hẹn giờ",
        player_min_aria: "Thu nhỏ về Mini Player", player_more_aria: "Tùy chọn khác", player_fav_aria: "Yêu thích",
        player_shuffle_aria: "Phát ngẫu nhiên", player_prev_aria: "Bài trước", player_play_aria: "Phát hoặc tạm dừng",
        player_next_aria: "Bài tiếp theo", player_repeat_aria: "Lặp lại", player_close_aria: "Đóng trình phát nhạc",
        toast_unliked: "Đã bỏ thích",
        toast_liked: "Đã thích bài viết! ❤️",
        toast_link_copied: "Đã sao chép liên kết vào bộ nhớ tạm!",
        toast_timer_stopped_end: "Hẹn giờ: Đã dừng phát khi hết bài hát",
        toast_shuffle_on: "Đã bật phát ngẫu nhiên",
        toast_shuffle_off: "Đã tắt phát ngẫu nhiên",
        toast_repeat_off: "Đã tắt lặp lại",
        toast_repeat_all: "Đang lặp lại danh sách",
        toast_repeat_one: "Đang lặp lại bài này",
        toast_fav_removed: "Đã bỏ khỏi bài hát yêu thích",
        toast_fav_added: "Đã thêm vào bài hát yêu thích! ❤️",
        toast_track_info_copied: "Đã sao chép thông tin bài hát!",
        toast_shuffle_play: "Đã trộn và phát bài ngẫu nhiên!",
        toast_speed_prefix: "Tốc độ phát: ",
        toast_muted: "Đã tắt tiếng",
        toast_unmuted: "Đã bật tiếng",
        toast_timer_off: "Đã tắt hẹn giờ",
        toast_timer_end_song: "Nhạc sẽ tự dừng khi hết bài hát này",
        toast_timer_after_prefix: "Hẹn giờ tắt nhạc sau ",
        toast_timer_stopped: "Hẹn giờ: Đã dừng phát nhạc",
        btt_aria: "Cuộn lên đầu trang",
        media_heading_full: "Kho Media & Đa Phương Tiện",
        media_works_unit: "tác phẩm",
        media_all_works: "Tất cả tác phẩm Media",
        media_cat_music: "Âm nhạc", media_cat_video: "Video", media_cat_audio: "Audio", media_cat_gallery: "Hình ảnh",
        cinema_footer_note: "Phát từ nền tảng video trong sạch Gan Jing World",
        cinema_open_gjw: "Mở trên GJW",
        lightbox_download_btn: "Tải ảnh gốc",
        reader_font_title: "Cỡ chữ bài đọc",
        reader_font_reset: "Mặc định",
        reader_font_family_label: "Kiểu chữ:",
        reader_font_serif: "Có chân",
        reader_font_sans: "Không chân",
        story_related_heading: "Bài viết cùng chủ đề",
        story_see_all: "Xem tất cả",
        story_toc_heading: "Mục lục nội dung",
        story_bookmark_label: "Thông điệp chiêm nghiệm",
        master_banner_section_title: "Tác phẩm đặc biệt",
        story_popular_heading: "Xem nhiều nhất",
        story_caption_default: "Ảnh tư liệu minh họa"
    },
    en: {
        nav_home: "Home", nav_explore: "Explore", nav_media: "Media", nav_references: "References", nav_chat: "Live Chat",
        search_placeholder: "Search...",
        search_clear_aria: "Clear search",
        mobile_search_title: "Search",
        lang_btn_aria: "Change language",
        theme_btn_aria: "Toggle light/dark theme",
        search_filter_all: "All", search_filter_articles: "Articles", search_filter_video: "Video", search_filter_audio: "Audio",
        search_recent: "Recent", search_clear_all: "Clear all", search_trending: "Trending Searches", search_featured: "Featured Suggestions",
        search_no_results: "No matching results found", search_history: "Search History",
        search_trending_title: "Popular Topics", search_all_results_for: "View all results for",
        home_badge: "Listen To Your Soul",
        home_title: "Miracles in Hue",
        card_health: "Health", card_work: "Career", card_love: "Love", card_family: "Family",
        card_spirit: "Spirituality", card_science: "Science", card_culture: "Traditional Culture",
        explore_now: "Explore now →", read_mins: "mins read",
        card_finance: "Finance", card_reincarnation: "Time Travel / Reincarnation",
        card_hue: "Hue", prompt_hue: "Miracles in Hue",
        card_danang: "Da Nang", prompt_danang: "Miracles in Da Nang",
        card_binhdinh: "Binh Dinh", prompt_binhdinh: "Miracles in Binh Dinh",
        card_vungtau: "Vung Tau", prompt_vungtau: "Miracles in Vung Tau",
        card_bentre: "Ben Tre", prompt_bentre: "Miracles in Ben Tre",
        story_answer_btn: "ANSWER: WHY MANKIND CAME TO BE",
        story_close_aria: "Close story",
        story_next_aria: "Next slide",
        story_prev_aria: "Previous slide",
        quiz_step_1: "Step 1 of 2", quiz_step_2: "Step 2 of 2",
        quiz_continue: "Continue", quiz_find_answer: "Find the answer", quiz_back: "Change answer",
        quiz_your_choice: "Your answer", quiz_close_aria: "Close", quiz_hint: "Pick an answer to continue",
        carousel_prev_aria: "Previous topic", carousel_next_aria: "Next topic",
        master_banner_author: "Founder of Falun Dafa published the article:",
        banner_title_1: "WHY DO HUMAN BEINGS EXIST",
        banner_title_2: "WHY SAVE ALL<br>SENTIENT BEINGS",
        banner_title_3: "WHY IS HUMAN SOCIETY<br>A DELUSION?",
        spotlight_title: "FEATURED STORIES",
        "sec_nhung-cau-chuyen-than-ky": "Miraculous Stories",
        "sec_gioi-thieu-phap-luan-dai-phap": "Introduction to Falun Dafa",
        "sec_vung-dat-con-nguoi": "Lands & People",
        "sec_chan-tuong-cuoc-buc-hai": "Truth of Persecution",
        "sec_van-hoa": "Culture & Arts",
        "sec_video": "Videos",
        "sec_su-kien": "Events & News",
        view_more: "View more", read_more: "Read more", share_action: "Share",
        network_title: "Reference Links",
        desc_mrsecret: "Decoding mysteries of the universe & humanity",
        desc_tantheky: "Authentic, humane news media",
        desc_ganjing: "Clean & safe video platform",
        desc_zhengjian: "Traditional culture & life science",
        desc_minghui: "Global Falun Dafa information",
        desc_falundafa: "Official information on Falun Dafa",
        desc_shenyun: "Reviving 5,000 years of civilization",
        desc_newcentury: "Inspiring independent film studio",
        breadcrumb_home: "Home", breadcrumb_explore: "Explore", breadcrumb_category: "Category",
        back: "Back", all_articles: "All articles", articles_unit: "articles",
        loading_more_articles: "Loading more articles...", load_more_btn: "Load more articles",
        all_articles_loaded: "All articles displayed",
        no_articles_in_cat: "No articles found in this category",
        no_articles_hint: "Please choose another category or reset filters to explore insightful articles.",
        view_all_articles_btn: "View all articles",
        story_posted_by: "Published by dieukydieu.tv • Deep dive",
        media_title: "Media Library", media_filter_all: "All", media_filter_video: "Video", media_filter_audio: "Audio",
        livechat_header_title: "dieukydieu.tv Support", livechat_online_status: "● Online",
        livechat_welcome_msg: "Welcome! dieukydieu.tv is always ready to listen and share about miracles of life, answering your questions regarding Falun Dafa, meditation, or life science. What would you like to explore today?",
        livechat_sug_1: "What is Falun Dafa?",
        livechat_sug_2: "5 Falun Dafa exercises guide",
        livechat_sug_3: "Are miracle healings real?",
        livechat_input_placeholder: "Type your question or message...",
        livechat_send_aria: "Send message", livechat_close_aria: "Close chat", chat_bubble_aria: "Open live chat support",
        share_modal_title: "Share Article", share_copy_link_btn: "Copy link",
        share_qr_instruction: "OR SCAN QR CODE ON MOBILE", share_copy_action: "Copy",
        toast_copied_text: "Link copied to clipboard!",
        player_playing_from: "PLAYING FROM", player_source_title: "Peaceful Collection",
        player_default_title: "Track Title", player_default_artist: "Artist",
        player_tab_track: "TRACK", player_tab_queue: "UP NEXT", player_tab_lyrics: "LYRICS",
        player_queue_heading: "Playlist Queue", player_shuffle_btn: "Shuffle",
        player_lyrics_heading: "Lyrics", player_lyrics_updating: "Lyrics are being updated...",
        player_options_title: "Track Options", player_sleep_timer: "Sleep Timer",
        player_timer_off: "Off", player_timer_min_suffix: "mins",
        player_speed: "Playback Speed", player_speed_normal: "1.0x (Normal)", player_speed_normal_word: "Normal",
        player_share: "Share Track", player_share_sub: "Copy link or share with friends",
        player_stop: "Turn off player",
        player_timer_15m: "15 mins", player_timer_30m: "30 mins", player_timer_45m: "45 mins", player_timer_60m: "60 mins",
        player_timer_track_end: "End of track", player_timer_cancel_btn: "Turn off timer",
        player_min_aria: "Minimize to Mini Player", player_more_aria: "More options", player_fav_aria: "Favorite",
        player_shuffle_aria: "Shuffle playback", player_prev_aria: "Previous track", player_play_aria: "Play or pause",
        player_next_aria: "Next track", player_repeat_aria: "Repeat", player_close_aria: "Close audio player",
        toast_unliked: "Article unliked",
        toast_liked: "Article liked! ❤️",
        toast_link_copied: "Link copied to clipboard!",
        toast_timer_stopped_end: "Sleep timer: Playback stopped at end of track",
        toast_shuffle_on: "Shuffle enabled",
        toast_shuffle_off: "Shuffle disabled",
        toast_repeat_off: "Repeat off",
        toast_repeat_all: "Repeating playlist",
        toast_repeat_one: "Repeating current track",
        toast_fav_removed: "Removed from favorites",
        toast_fav_added: "Added to favorites! ❤️",
        toast_track_info_copied: "Track info copied!",
        toast_shuffle_play: "Shuffled & playing random track!",
        toast_speed_prefix: "Playback speed: ",
        toast_muted: "Muted",
        toast_unmuted: "Unmuted",
        toast_timer_off: "Timer turned off",
        toast_timer_end_song: "Music will stop at the end of this track",
        toast_timer_after_prefix: "Sleep timer set for ",
        toast_timer_stopped: "Sleep timer: Playback stopped",
        btt_aria: "Scroll to top",
        media_heading_full: "Media & Multimedia Library",
        media_works_unit: "works",
        media_all_works: "All Media Works",
        media_cat_music: "Music", media_cat_video: "Video", media_cat_audio: "Audio", media_cat_gallery: "Gallery",
        cinema_footer_note: "Powered by clean video platform Gan Jing World",
        cinema_open_gjw: "Open on GJW",
        lightbox_download_btn: "Download HD",
        reader_font_title: "Article Font Size",
        reader_font_reset: "Default",
        reader_font_family_label: "Font:",
        reader_font_serif: "Serif",
        reader_font_sans: "Sans",
        story_related_heading: "Related Stories",
        story_see_all: "See all",
        story_toc_heading: "In This Story",
        story_bookmark_label: "Reflective Quote",
        master_banner_section_title: "Special Works",
        story_popular_heading: "Most Read",
        story_caption_default: "Illustrative photo"
    },
};
